import { toast } from 'react-toastify'
import ContactModal, { ContactDefaultValues } from './ContactModal/ContactModal'
import useApiService from '../../services/api'
import { ContactResponse } from '../../models/contacts'
import { ContactCompany } from 'models/companies'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

export default function EditContactModal({
  show,
  handleClose,
  onContactUpdated,
  contact,
  forCompany,
  initialDoorIds,
}: {
  show: boolean
  handleClose: () => void
  onContactUpdated?: () => void
  contact: ContactResponse
  forCompany?: Partial<ContactCompany>
  initialDoorIds?: number[]
}) {
  const api = useApiService()
  // Dark-launch gate for the @firstbite/ui (DS2026) contact modal — same flag
  // as the add flow (NewContactModal); off by default → legacy modal.
  const { enableDs2026ContactModal } = useFeatureFlagService()

  const handleSubmitSuccess = () => {
    toast.success('Contact updated successfully')
    onContactUpdated?.()
    handleClose()
  }

  const updateContact = (values: ContactDefaultValues) => {
    return api.updateContact(contact.id, {
      ...values,
      contact_company: {
        ...values.contact_company,
        domain: values.company_domain,
      },
    })
  }

  const { data: contactDetails, isLoading: isContactDetailsLoading } =
    api.useGetContactDetails(contact.id)

  // Wait for contact details to load before rendering the modal.
  // This ensures door_ids are available in defaultValues so no sync
  // useEffect is needed inside ContactModal.
  if (isContactDetailsLoading) return null

  return (
    <ContactModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Update"
      submitApiAction={updateContact}
      contactToEdit={contact}
      initialDoorIds={contactDetails?.door_ids || initialDoorIds}
      initialNotes={contactDetails?.notes}
      forCompany={forCompany}
      ds2026={enableDs2026ContactModal}
    />
  )
}
